<template>
  <!-- -->
  <div class="product-search-show">
    <div class="search-input">
      <yq-icon name="iconfont_search" class="input-icon"/>
      <div class="input-key">
        {{settingData.text}}
      </div>
    </div>
  </div>
</template>

<script>


import {watch} from "vue";

export default {
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
  },
  data() {
    return {
      settingData: {text: "搜索商品"},
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {};
      } else {
        this.settingData = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-search-show{
  padding: 20px;
  border-radius: 10px;
  .search-input{
    background: var(--yq-background-color);
    position: relative;
    box-sizing: border-box;
    padding-left: 80px;
    color: var(--yq-font-color-desc);
    .input-icon{
      width: 80px;
      text-align: center;
      line-height: 80px;
      position: absolute;
      left: 30px;
      top: 0;
      font-size: var(--font-size-large);
      color: var(--font-color-desc);
    }
    .input-key{
      height: 80px;
      line-height: 80px;
      color: var(--font-color-desc);
      white-space: nowrap;
      overflow: hidden;
      font-size: 24px;
    }
  }
}
</style>